import { BalloonParameter } from "../GameObjects/DebugBalloonControls";

export class BalloonControlToken {
    public readonly parameter: BalloonParameter;
    public readonly value: number;

    constructor(pParam: BalloonParameter, pValue: number) {
        this.parameter = pParam;
        this.value = pValue;
    }
}
